var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',[_c('v-tab',[_vm._v(" Admin Users ")]),_c('v-tab',[_vm._v(" Portal Users ")]),_c('v-tab-item',[_c('users-table-component')],1),_c('v-tab-item',[_c('users-table-component',{attrs:{"is-portal-user-table":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }